import React, { useEffect, useState } from 'react';
import { v4 as uuid4 } from 'uuid';
import cn from 'classnames';
import Typography from '@components/typography';

import '@styles/buttongroup.scss';

export interface ButtonFields {
  // Identicaly value of button
  Id: string;
  // Button Text
  Label: string;
  // Button Active Text Class because of Typography
  ActiveTextClassName?: string;
  // Button Normal Text Class because of Typography
  NormalTextClassName?: string;
}

interface ButtonGroupProps {
  // Button list
  buttons: ButtonFields[];
  // Event to get active button
  onClick?: (selected: string) => void;
  // Override default button style
  buttonClassName?: string;
  // Override default active button style
  activeButtonClassName?: string;
  // Override button group container style
  className?: string;
  activeButton?: number;
  dataTestId?: string;
}

const ButtonGroup: React.FC<ButtonGroupProps> = ({
  buttons,
  onClick,
  buttonClassName,
  activeButtonClassName,
  className,
  activeButton = 0,
  dataTestId,
}) => {
  const [active, setActive] = useState(activeButton);

  const handleClick = (id: number) => {
    setActive(id);

    if (onClick) {
      onClick(buttons[id].Id);
    }
  };

  useEffect(() => {
    handleClick(activeButton);
  }, [activeButton]);

  return (
    <div
      data-cy="button-group"
      data-testid={dataTestId ? dataTestId : 'button-group'}
      className={cn('button-group', className)}
    >
      {buttons.map((button, index) => (
        <button
          key={uuid4()}
          onClick={() => handleClick(index)}
          data-cy={`button-group__custom-button-${index}`}
          data-testid={`button-group__custom-button-${index}`}
          className={cn(
            'button-group__custom-button',
            index === active &&
              (activeButtonClassName
                ? activeButtonClassName
                : 'button-group__custom-button--active'),
            buttonClassName
          )}
        >
          <Typography
            size="lg"
            variant="button"
            className={cn(
              button.ActiveTextClassName && index === active
                ? button.ActiveTextClassName
                : '',
              button.NormalTextClassName ? button.NormalTextClassName : ''
            )}
          >
            {button.Label}
          </Typography>
        </button>
      ))}
    </div>
  );
};

export default ButtonGroup;
